import formatMoney from '../utils/formatMoney';

const toggleAtcNotification = (product) => {
  const atcNotificationEl = document.querySelector('[data-atc-notification]');
  if (!atcNotificationEl) return;
  const closeNotificationBtn = atcNotificationEl.querySelectorAll('[data-atc-notification-close]');
  const notificationPriceEl = atcNotificationEl.querySelector('[data-atc-notification-price]');

  const closeNotification = () => {
    atcNotificationEl.classList.toggle('translate-x-full', true);
  };

  if (notificationPriceEl && product) {
    notificationPriceEl.textContent = formatMoney(product.items[0].price);
  }

  if (product && product.items.length > 1) {
    const notificationBodyEl = atcNotificationEl.querySelector('[data-atc-notification-body]');
    if (notificationBodyEl) {
      const additionalProductPrice = formatMoney(product.items[1].price);
      const additionalProductTitle = product.items[1].product_title;
      const additionalProductImageSrc = product.items[1].image;
      const additionalProductImageAlt = product.items[1].title;

      const additionalProductHTML = `
        <div class="flex items-center gap-[15px] bg-white px-5 py-[15px] border-b border-light-grey">
          <img class="shrink-0 w-[100px]" src="${additionalProductImageSrc}" alt="${additionalProductImageAlt}" width="100" height="90" />
          <div class="flex flex-col gap-2.5">
            <p>${additionalProductTitle}</p>
            <p>${additionalProductPrice}</p>
          </div>
        </div>
      `;

      notificationBodyEl.insertAdjacentHTML('afterbegin', additionalProductHTML);
    }
  }

  const isOpen = atcNotificationEl.classList.toggle('translate-x-full', false);

  closeNotificationBtn.forEach(closeBtn => closeBtn.addEventListener('click', closeNotification));

  document.addEventListener('click', (event) => {
    if (!atcNotificationEl.contains(event.target)) closeNotification();
  });

  document.addEventListener('keydown', (evt) => {
    if (evt.key === 'Escape' && !isOpen) {
      closeNotification();
    }
  });
};

export default toggleAtcNotification;
